export default __webpack_public_path__ + "./images/d_accel_yoko.png";